import React from 'react';
import {Separator} from '../components/ui/separator';

import {VersionInfo} from './VersionInfo';
import {Disclaimer} from './Disclaimer';
import {About} from './About';

/**
 * Help / about page.
 */
export const Help = () => {
  return (
    <div className="max-w-4xl p-8 mx-auto">
      {/* About Nudge Section */}
      <section>
        <h2 className="text-2xl font-semibold text-secondary mb-4">
          About Nudge
        </h2>
        <div className="max-w-none">
          <About />
        </div>
      </section>

      <Separator className="my-8" />

      {/* Nudge Info Section */}
      <section>
        <h2 className="text-2xl font-semibold text-secondary mb-4">
          Nudge Info
        </h2>
        <VersionInfo />
      </section>

      <Separator className="my-8" />

      {/* Disclaimers Section */}
      <section>
        <h2 className="text-2xl font-semibold text-secondary mb-4">
          Disclaimers
        </h2>
        <div className="max-w-none">
          <Disclaimer />
        </div>
      </section>
    </div>
  );
};
